module.exports = __webpack_public_path__ + "static/media/task.bec87501.svg";